var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.topbar},[_c('div',{staticClass:"mr-auto"}),_c('div',{staticClass:"float-right"},[_c('cui-user-menu')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }